import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faChevronLeft, faQuoteLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import team1 from '../../assets/img/bg9.jpg';
import team2 from '../../assets/img/bg8.jpg';
import team3 from '../../assets/img/bg10.jpg';
import thumbnail from '../../assets/portifolio/Wedesera.jpg';
import marketing from '../../assets/Video/ATO show reel 0.1.mp4';


const OurStory = () => {
  const navigate = useNavigate();
  const [isPlaying, setIsPlaying] = useState(false);

  const milestones = [
    {
      year: '2018',
      title: 'Three Minds Meet',
      description: 'Our founders connected at a design conference, discovering their shared passion for culturally-rooted creativity.'
    },
    {
      year: '2019',
      title: 'First Client Project',
      description: 'Landing our first major client proved our collaborative approach could deliver exceptional results.'
    },
    {
      year: '2020',
      title: 'Pandemic Pivot',
      description: 'We adapted to remote collaboration, strengthening our digital-first approach to creative work.'
    },
    {
      year: '2022',
      title: 'Team Expansion',
      description: 'Grew from 3 to 12 full-time creatives while maintaining our tight-knit culture.'
    },
    {
      year: '2023',
      title: 'Award Recognition',
      description: 'Received the "Emerging Creative Agency of the Year" award from Design Week.'
    }
  ];

  const teamMembers = [
    {
      name: 'Abel Mindaye',
      role: 'CEO of Ato Creative',
      image: team1,
      quote: '"Our name reminds us that great work always comes back to human connection."'
    },
    {
      name: 'Defar Gobeze',
      role: 'Software Engineer',
      image: team2,
      quote: '"Three perspectives mean we never approach a problem the same way twice."'
    },
    {
      name: 'Eyoub Wondimu',
      role: 'Graphic Designer',
      image: team3,
      quote: '"The tech exists to serve the story, not the other way around."'
    }
  ];

  return (
    <div className="h-full mb-4 bg-white">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#FD5F20] to-[#FF8C5A] text-white py-20 px-4 md:px-8">
        <button 
          onClick={() => navigate(-1)}
          className="absolute top-6 left-6 flex items-center gap-2 text-white hover:text-gray-100 transition-colors"
        >
          <FontAwesomeIcon icon={faChevronLeft} />
          <span>Back</span>
        </button>
        
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">Our Story</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            How three became a creative force blending culture, technology, and strategy
          </p>
        </div>
      </div>

      {/* Video Section */}
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-16">
        <div className="aspect-w-16 aspect-h-9 bg-black rounded-2xl overflow-hidden shadow-2xl relative">
          {!isPlaying ? (
            <div className="absolute inset-0 flex items-center justify-center">
              <button 
                onClick={() => setIsPlaying(true)}
                className="bg-[#FD5F20] hover:bg-[#e0551d] transition-all duration-300 p-6 rounded-full flex items-center justify-center"
              >
                <FontAwesomeIcon icon={faPlay} className="text-white text-2xl ml-1" />
              </button>
            </div>
          ) : null}
          
          <div className="relative w-full" style={{ height: '400px' }}> {/* Fixed height container */}
  {!isPlaying ? (
    <div className="relative w-full h-full bg-gray-800 rounded-xl overflow-hidden">
      {/* Video thumbnail placeholder - replace with your actual thumbnail image */}
      <div className="absolute inset-0 bg-gray-700 flex items-center justify-center">
        <img 
          src={thumbnail} 
          alt="Video thumbnail" 
          className="w-full h-full object-cover opacity-70"
        />
      </div>
      
      {/* Play button overlay */}
      <div className="absolute inset-0 flex items-center justify-center">
        <button 
          onClick={() => setIsPlaying(true)}
          className="bg-[#FD5F20] hover:bg-[#e0551d] transition-all duration-300 p-5 rounded-full flex items-center justify-center  hover:scale-110"
        >
          <FontAwesomeIcon 
            icon={faPlay} 
            className="text-white text-2xl ml-1" 
            style={{ width: '24px', height: '24px' }}
          />
        </button>
      </div>
      
      {/* Video title overlay */}
      <div className="absolute bottom-6 left-6 text-white">
        <h3 className="text-xl font-bold">Our Creative Journey</h3>
        <p className="text-sm">2:45 min</p>
      </div>
    </div>
  ) : (
    <div className="w-full h-full rounded-xl overflow-hidden ">
      <iframe 
        width="100%" 
        height="100%" 
        src={marketing} 
        title="Our Story Video" 
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen
        className="w-full h-full"
      />
    </div>
  )}
</div>
        </div>
      </div>

      {/* The Meaning Behind Our Name */}
      <div className="bg-[#FFF5F1] py-16 px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">The Meaning Behind "Ato"</h2>
            <div className="w-24 h-1 bg-[#FD5F20] mx-auto"></div>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl font-bold mb-4 text-[#FD5F20]">Igbo: "Three"</h3>
              <p className="text-gray-700 mb-8 text-lg leading-relaxed">
                In the Igbo language of Nigeria, "ato" signifies the number three - representing our three founders and the power of collaboration. 
                Just as three strands make a stronger rope, our combined perspectives create work that's more insightful and innovative.
              </p>
              
              <h3 className="text-2xl font-bold mb-4 text-[#FD5F20]">Amharic: "Mister"</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                In Ethiopia's Amharic language, "Ato" is a respectful title for a man. This reflects our approach - bringing dignity, 
                respect and thoughtful consideration to every project and partnership.
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-xl ">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 rounded-full bg-[#FD5F20] flex items-center justify-center text-white font-bold text-xl mr-4">3</div>
                <h4 className="text-xl font-bold">Three Core Principles</h4>
              </div>
              
              <ul className="space-y-6">
                <li className="flex items-start">
                  <div className="bg-[#FFF5F1] text-[#FD5F20] rounded-full w-8 h-8 flex items-center justify-center mr-4 mt-1 flex-shrink-0">1</div>
                  <div>
                    <h5 className="font-bold mb-1">Cultural Depth</h5>
                    <p className="text-gray-600">Rooting creativity in authentic human experiences</p>
                  </div>
                </li>
                
                <li className="flex items-start">
                  <div className="bg-[#FFF5F1] text-[#FD5F20] rounded-full w-8 h-8 flex items-center justify-center mr-4 mt-1 flex-shrink-0">2</div>
                  <div>
                    <h5 className="font-bold mb-1">Collaborative Strength</h5>
                    <p className="text-gray-600">Combining diverse perspectives for better solutions</p>
                  </div>
                </li>
                
                <li className="flex items-start">
                  <div className="bg-[#FFF5F1] text-[#FD5F20] rounded-full w-8 h-8 flex items-center justify-center mr-4 mt-1 flex-shrink-0">3</div>
                  <div>
                    <h5 className="font-bold mb-1">Respectful Practice</h5>
                    <p className="text-gray-600">Honoring every client's unique vision and needs</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Our Journey Timeline */}
      <div className="py-16 px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Journey</h2>
            <div className="w-24 h-1 bg-[#FD5F20] mx-auto"></div>
          </div>
          
          <div className="relative">
            {/* Timeline line */}
            <div className="absolute left-4 md:left-1/2 h-full w-0.5 bg-gray-200 transform -translate-x-1/2"></div>
            
            <div className="space-y-12">
              {milestones.map((milestone, index) => (
                <div 
                  key={index}
                  className={`relative flex ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-start`}
                >
                  <div className="hidden md:block md:w-1/2"></div>
                  
                  <div className="md:w-1/2 pl-12 md:pl-16 pr-4 md:pr-16">
                    <div className="relative">
                      {/* Year marker */}
                      <div className="absolute -left-12 md:-left-16 w-8 h-8 rounded-full bg-[#FD5F20] flex items-center justify-center text-white font-bold">
                        {milestone.year}
                      </div>
                      
                      <div className="bg-white p-6 rounded-xl  hover: transition-shadow duration-300">
                        <h3 className="text-xl font-bold mb-2">{milestone.title}</h3>
                        <p className="text-gray-600">{milestone.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Meet the Founders */}
      <div className="bg-gray-50 py-16 px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Meet the Founders</h2>
            <div className="w-24 h-1 bg-[#FD5F20] mx-auto"></div>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <div key={index} className="bg-white rounded-xl overflow-hidden  hover: transition-shadow duration-300">
                <div className="h-64 overflow-hidden">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    title={`Ato Creative member ${index+1} `}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold">{member.name}</h3>
                  <p className="text-[#FD5F20] mb-4">{member.role}</p>
                  
                  <div className="relative">
                    <FontAwesomeIcon 
                      icon={faQuoteLeft} 
                      className="text-gray-200 text-4xl absolute -top-8 left-0"
                    />
                    <p className="text-gray-600 italic relative z-10">{member.quote}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="py-16 px-4 md:px-8 bg-gradient-to-r from-[#FD5F20] to-[#FF8C5A] text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Write Your Story?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Let's collaborate to create something remarkable together.
          </p>
          <button className="bg-white text-[#FD5F20] hover:bg-gray-100 transition-colors duration-300 px-8 py-4 rounded-full font-bold text-lg">
        
            <a href="/atocreative/Project" className="font-semibold hover:text-white transition">
     Start Your Project
</a>   
          </button>
        </div>
      </div>  
    </div>
  );
};

export default OurStory;